module.exports = __webpack_public_path__ + "img/website-groups.050a2f10.png";